import React from 'react';
import SubjectPage from '../structure/SubjectPage';

const OOPS_AI = ({ branch = "AIML", semester = "4th Semester" }) => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>Object Oriented Paradigm: Procedural vs. Object Oriented Programming, Concept of
        Abstraction, Encapsulation, Polymorphism and Inheritance.
        C++ Overview: Basic Structure of C++ program, Character set, Tokens, keywords,
        Data types, operators, scope resolution operator, Memory management operators.
        Classes and Objects: Class specification, Class objects, Accessing class members,
        Defining member functions, Memory allocation for objects, Static data members and
        functions, Array of objects.
      </p>
    </div>,
    <div key="2" className="p-4">
      <p>Constructors and Destructors: Introduction, Parameterized constructors, Default
        constructors, Copy constructor, Dynamic constructors, Destructors.
        Function Overloading and Friend function: Function prototyping, Inline functions,
        Call by reference, Friend functions, Friend classes.
        Operator Overloading: Introduction, Overloading unary and binary operators, Data
        conversions.
      </p>
    </div>,
    <div key="3" className="p-4">
      <p>Inheritance: Introduction, Derived classes, Single inheritance, Multiple inheritance,
        Hierarchical inheritance, Multilevel inheritance, Hybrid inheritance, Virtual base classes,
        Abstract classes.
        Virtual Functions and Polymorphism: Introduction, Pointers to objects, this pointer,
        Pointers to derived classes, Virtual functions, Pure virtual functions.
      </p>
    </div>,
    <div key="4" className="p-4">
      <p>Templates and Exception Handling: Introduction, Class templates, Function templates,
        Member function templates, Exception handling mechanism: throw, try, catch.
        Input/Output Streams: C++ stream classes, Formatted and unformatted I/O operations,
        File Handling: Opening and closing files, Sequential and random access files.
      </p>
    </div>
  ];

  const tabData = [
    { id: 'syllabus', label: 'Syllabus', content: null },
    { id: 'notes', label: 'Notes', content: null },
    { id: 'important', label: 'Important Questions', content: null },
    { id: 'books', label: 'Books', content: null },
    { id: 'PYQ', label: 'PYQ', content: null },
    { id: 'youtube_playlist', label: 'Video Lectures', content: null },
  ];

  return (
    <SubjectPage
      subjectName="Object Oriented Programming"
      subjectKey="AI_OOPS"
      branch={branch}
      semester={semester}
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
      firestoreCollections={{
        notes: 'AIOOPSNotes',
        videos: 'AIOOPSVideos'
      }}
    />
  );
};

export default OOPS_AI;
